import { Suspense, lazy } from 'react';

import { DynamicBaseBreadcrumb, DynamicDnsRecordsBreadcrumb } from '../../modules/AppBreadcrumb';
import { Spinner } from '../components';
import { AppControllerType, AppRoutes } from '../interfaces/router';

const DnsRecordsCreatePage = lazy(() => import('../../pages/DnsRecords/DnsRecordsCreate.page'));
const DnsRecordsListPage = lazy(() => import('../../pages/DnsRecords/DnsRecordsList.page'));
const DnsRecordsPage = lazy(() => import('../../pages/DnsRecords/DnsRecords.page'));

export const DnsRecordsController: AppControllerType = {
  common: [
    {
      path: AppRoutes.DnsRecords + '/*',
      element: (
        <Suspense fallback={ <Spinner/> }>
          <DnsRecordsListPage/>
        </Suspense>
      ),
      breadcrumb: DynamicDnsRecordsBreadcrumb.DynamicDnsRecordsListBreadcrumb
    }
  ],
  drawer: [
    {
      path: AppRoutes.DnsRecordsCreate,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <DnsRecordsCreatePage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseCreateBreadcrumb,
      props: {
        commonDrawerWidth: 500
      }
    },
    {
      path: AppRoutes.DnsRecordsById,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <DnsRecordsPage/>
        </Suspense>
      ),
      breadcrumb: DynamicDnsRecordsBreadcrumb.DynamicDnsRecordsByIdBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    }
  ]
};
